import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  COUPON_SEARCH,
	COUPON_LIST_FETCH,
	COUPON_DETAIL_FETCH,
	COUPON_LIST_PROFILE_FETCH,
} from "../actions/types";
import {
  couponCountTotal,
  couponListFetchSuccess,
  couponDetailFetchSuccess,
} from "../actions";
import { showErrorMessage} from "../actions/NotifyActions";
import { authSignOutSuccess } from "../actions/AuthActions";
import {
	authorizationHeader,
	getErrorMessage_v2,
	getFilterUrl
} from "./../utils/apiUtil";
import axiosRetry from 'axios-retry';


axiosRetry(axios, {retries:3, retryDelay: (retryCount) => {
  return retryCount * 1000;
}});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;


export const couponListFetchRequest = async (payload = "") => {
	return await axios
		.get(`${REACT_APP_API_URL}/v1/coupons/my-coupon`, {
      headers: authorizationHeader("Bearer"),
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

const couponListProfileFetchRequest = async (payload = "") => {
	return await axios
		.get(`${REACT_APP_API_URL}/v1/member/coming-coupon-expired${payload}`, {
			// v1/member/coupon-expired
      headers: authorizationHeader("Bearer"),
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

const couponDetailFetchRequest = async (payload) => {
  return await axios
    .get(`${REACT_APP_API_URL}/v1/coupon/${payload}`,{
      headers: authorizationHeader("Bearer"),
    })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

// WORKER

function* couponSearch({payload}) {
	try {
		const filter = getFilterUrl(payload);
		const data = yield call(couponListFetchRequest, filter);
	
		yield put(couponCountTotal(data.length));
		yield put(couponListFetchSuccess(data));
	} catch (error) {
		if(error.response && error.response.status && error.response.status === 401){
			localStorage.removeItem("member");
			yield put(authSignOutSuccess());
		}else{
			yield put(showErrorMessage(getErrorMessage_v2(error.response)));
		}
	}
}

function* couponListFetch({payload}) {
	try {
		const data = yield call(couponListFetchRequest, payload);
		
		yield put(couponCountTotal(data.length));
		yield put(couponListFetchSuccess(data.mycoupon));
	
	} catch (error) {
		if(error.response && error.response.status && error.response.status === 401){
			localStorage.removeItem("member");
			yield put(authSignOutSuccess());
		}else{
			yield put(showErrorMessage(getErrorMessage_v2(error.response)));
		}
	}
}

function* couponDetailFetch({ payload }) {
	try {
		const data = yield call(couponDetailFetchRequest, payload);
		yield put(couponDetailFetchSuccess(data));
	} catch (error) {
		if(error.response && error.response.status && error.response.status === 401){
			localStorage.removeItem("member");
			yield put(authSignOutSuccess());
		}else{
			yield put(showErrorMessage(getErrorMessage_v2(error.response)));
		}
	}
}

function* couponListProfileFetch({payload}) {
	try {
		const data = yield call(couponListProfileFetchRequest, payload);
		yield put(couponCountTotal(data.length));
		yield put(couponListFetchSuccess(data));
	} catch (error) {
		if(error.response && error.response.status && error.response.status === 401){
			localStorage.removeItem("member");
			yield put(authSignOutSuccess());
		}else{
			yield put(showErrorMessage(getErrorMessage_v2(error.response)));
		}
	}
}



// WATCHER
export function* couponSearchWatcher() {
	yield takeEvery(COUPON_SEARCH, couponSearch);
}

export function* couponListFetchWatcher() {
	yield takeEvery(COUPON_LIST_FETCH, couponListFetch);
}

export function* couponListProfileFetchWatcher() {
	yield takeEvery(COUPON_LIST_PROFILE_FETCH, couponListProfileFetch);
}



export function* couponDetailFetchWatcher() {
	yield takeEvery(COUPON_DETAIL_FETCH, couponDetailFetch);
}



export default function* rootSaga() {
	yield all([
		fork(couponSearchWatcher),
		fork(couponListFetchWatcher),
		fork(couponDetailFetchWatcher),
		fork(couponListProfileFetchWatcher),

	]);
}
